import {CompositionCustomizationService} from '@app/model-composer/services/composition-customization.service';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-customization-group-selector',
  standalone: true,
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @let g = groups();
    @let active = activeId();
    @if (g?.length > 1) {
      <div class="ipe:flex ipe:overflow-hidden ipe:border-b ipe:border-gray-100">
        @for (group of g; track group.id) {
          @let isActive = group.id === active;
          <button
            class="
              ipe:flex-1
              ipe:px-4 ipe:py-5
              ipe:text-sm ipe:font-medium
              ipe:cursor-pointer ipe:select-none
              ipe:transition-colors ipe:duration-200
              ipe:bg-white hover:ipe:bg-gray-50
            "
            [ngClass]="isActive
              ? 'ipe:text-[#18181b]'
              : 'ipe:text-gray-400'
            "
            (click)="select(group.id)"
          >
            {{ group.label }}
          </button>
        }
      </div>
    }
  `
})
export class CustomizationGroupSelectorComponent {
  private service = inject(CompositionCustomizationService);
  readonly groups = this.service.groups;
  readonly activeId = this.service.activeGroupId;

  select(id: string): void {
    this.service.setActiveGroup(id);
  }
}
